/**
 *  ######################################
 *  ### DO NOT EDIT THIS FILE DIRECTLY ###
 *  ######################################
 *
 * This file is generated from:
 * /crates/mgo-open-rpc/spec/openrpc.json
 */

import type { GetLatestCheckpointSequenceNumberParams } from '@mgonetwork/mango.js/client';

import type { UseMgoClientQueryOptions } from '../useMgoClientQuery.js';
import { useMgoClientQuery } from '../useMgoClientQuery.js';

export function useLatestCheckpointSequenceNumber(
	params: GetLatestCheckpointSequenceNumberParams = {},
	options?: UseMgoClientQueryOptions<'getLatestCheckpointSequenceNumber'>,
) {
	return useMgoClientQuery(
		{
			method: 'getLatestCheckpointSequenceNumber',
			params,
		},
		options,
	);
}
